import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import AdminLayout from "@/components/layout/AdminLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ActivityIcon } from "lucide-react";
import { useState } from "react";
import { ActivityFilters, type ActivityFilters as FilterType } from "@/components/activity/ActivityFilters";
import { ActivityList } from "@/components/activity/ActivityList";
import { ActivityType } from "@/integrations/supabase/types/common";

export default function Activity() {
  const [filters, setFilters] = useState<FilterType>({
    creator: "all",
    activityType: "all",
    startDate: undefined,
    endDate: undefined,
  });

  const { data: logs, isLoading } = useQuery({
    queryKey: ["activity-logs", filters],
    queryFn: async () => {
      console.log("Fetching activity logs...");
      let query = supabase
        .from("activity_logs")
        .select(`
          *,
          creators (
            name,
            surname,
            nick_name
          )
        `)
        .order("created_at", { ascending: false });

      // Apply filters
      if (filters.creator && filters.creator !== "all") {
        query = query.eq('creator_id', parseInt(filters.creator));
      }

      if (filters.activityType !== "all") {
        query = query.eq("activity_type", filters.activityType as ActivityType);
      }

      if (filters.startDate) {
        query = query.gte("created_at", filters.startDate.toISOString());
      }

      if (filters.endDate) {
        query = query.lte("created_at", filters.endDate.toISOString());
      }

      const { data, error } = await query;

      if (error) {
        console.error("Error fetching activity logs:", error);
        throw error;
      }

      console.log("Activity logs fetched:", data);
      return data;
    },
  });

  return (
    <AdminLayout>
      <div className="space-y-4">
        <h1 className="text-3xl font-bold">Activity Log</h1>
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <ActivityIcon className="h-5 w-5" />
              Recent Activity
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ActivityFilters filters={filters} onFiltersChange={setFilters} />
            <ActivityList logs={logs || []} isLoading={isLoading} />
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
}